module.exports = __webpack_public_path__ + "img/ic_PDF2.04cd76d4.svg";